import { Injectable } from '@angular/core';
import { ApiClientService } from 'projects/dnest-core-angular/src/public-api';
import { Treatment } from 'src/app/models/treatment';

@Injectable({
  providedIn: 'root'
})
export class TreatmentApiClientService extends ApiClientService<Treatment> {
  endpoint = 'treatment';
}

